var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.toast.isOpen)?_c('v-alert',{staticClass:"toast",class:{
    'is-open': _vm.toast.isOpen
  },attrs:{"outlined":"","text":"","type":_vm.toast.type || 'info'}},[_vm._v("\n  "+_vm._s(_vm.toast.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }